import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export const getDocuments = withNextApi<
  GetDocumentsResponse,
  GetDocumentsParameters
>("/cvp/CvpGetDocuments");

export interface GetDocumentsParameters extends NextApiParams {}

export interface GetDocumentsResponse extends BackendResponse {
  items: DocumentInfo[];
}
export interface DocumentInfo {
  idEmployee: number;
  idDepartment: number;
  idFirm: number;
  id: number;
  version: number;
  fileType: string;
  name: string;
  folder: string;
  isTemplate: boolean;
  typeRelatedTo: number;
  idRelatedTo: number;
  candidateAvailable: boolean;
  customerAvailable: boolean;
  registered: string | null;
  expirationDate: string | null;
  changed: string | null;
  deleted: string | null;
  idEmployeeRegisteredBy: number;
  idEmployeeChangedBy: number;
}
